import { useState } from "react";
import { IoClose } from "react-icons/io5";

import TableControls from "../../../components/common/TableControls";
import TableSize from "../../../components/common/TableSize";
import TextboxSearch from "../../../components/common/TextboxSearch";
import Modal from "../../../components/common/Modal";
import InvoicesFilter from "./InvoicesFilter";

import moment from "moment";

const InvoicesHeader = ({ options, onChange }) => {
  const [showFilter, setShowFilter] = useState(false);

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.status = "";
      new_options.year = "";
      new_options.month = "";
      new_options.date = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (status, posted, year, month, date) => {
    const new_options = { ...options };
    new_options.status = status;
    new_options.posted = posted;
    new_options.year = year;
    new_options.month = month;
    new_options.date = date;
    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };

    if (item === 1) new_options["status"] = "";
    if (item === 2) new_options["posted"] = "";
    if (item === 3) new_options["year"] = "";
    if (item === 4) new_options["month"] = "";

    onChange(new_options);
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500">Invoices</p>
          <span className="text-gray-400 text-sm">Summary of Invoices</span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
        </div>
      </div>
      <div className="mt-2 float-right">
        <div className="flex gap-2">
          {options.status !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              Status: {options.status ? "Paid" : "Unpaid"}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
          {options.posted !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {options.posted ? "Posted" : "Unposted"}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(2)}
              />
            </div>
          )}
          {options.year && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              Year: {options.year}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(3)}
              />
            </div>
          )}
          {options.month && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              Month:{" "}
              {moment()
                .month(options.month - 1)
                .format("MMMM")}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(4)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        borderTop
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        children={<InvoicesFilter options={options} onFilter={handleFilter} />}
      />
    </>
  );
};

export default InvoicesHeader;
